import * as React from 'react';
import './ServiceButton.scss';
/**
 * Service button component
 *
 * @param props
 * @constructor
 */
var ServiceButton = function (props) {
    var service = props.service;
    return (React.createElement("a", { href: service.url, className: "btn-service" },
        React.createElement("img", { src: service.image, alt: service.title })));
};
export default ServiceButton;
//# sourceMappingURL=ServiceButton.js.map